(function () {
  'use strict';

  function money(cents, root) {
    var locale = document.documentElement.lang || 'fr-FR';
    var currency = (root && root.getAttribute('data-currency')) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format((Number(cents) || 0) / 100);
  }

  function setSelected(card, group) {
    group.forEach(function (item) {
      item.classList.remove('is-selected');
      var radio = item.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    card.classList.add('is-selected');
    var selected = card.querySelector('input[type="radio"]');
    if (selected) selected.checked = true;
  }

  function setPressed(selected, group) {
    group.forEach(function (item) {
      var active = item === selected;
      item.classList.toggle('is-selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function suppressUnverifiedReviewCards() {
    document.querySelectorAll('#trustoo-widget-wrapper, #tt-carousels-wrapper, #tt-carousel, #reviews-wrapper, #noreviews-wrapper, #vstar-noreviews, .trustoo-reviews-wrapper').forEach(function (widget) {
      if (widget.closest('.gdp-jv3f__reviews')) return;
      widget.hidden = true;
      widget.setAttribute('aria-hidden', 'true');
      widget.style.setProperty('display', 'none', 'important');
      widget.style.setProperty('min-height', '0', 'important');
      widget.style.setProperty('height', '0', 'important');
    });
  }

  function setupFoodDetails(root) {
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-food-detail]'));
    details.forEach(function (detail) {
      if (detail.dataset.gdpLegacyFoodReady === 'true') return;
      detail.dataset.gdpLegacyFoodReady = 'true';
      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        details.forEach(function (other) {
          if (other !== detail) other.open = false;
        });
      });
    });
  }

  function setupSticky(root, primaryButton) {
    var sticky = root.querySelector('[data-gdp-legacy-sticky]');
    var footer = Array.prototype.slice.call(document.querySelectorAll('.shopify-section-group-footer-group footer, footer[id*="__footer"], #shopify-section-footer footer, #shopify-section-footer, [data-section-type="footer"]')).filter(function (candidate) {
      return !candidate.closest('[data-gdp-legacy], .gdp-legacy__food');
    })[0] || null;
    if (!sticky || !primaryButton || !('IntersectionObserver' in window)) return;

    var primaryVisible = true;
    var footerVisible = false;
    var stickyButton = sticky.querySelector('button');
    var render = function () {
      var visible = !primaryVisible && !footerVisible && !primaryButton.disabled;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (stickyButton) stickyButton.tabIndex = visible ? 0 : -1;
    };

    var primaryObserver = new IntersectionObserver(function (entries) {
      primaryVisible = entries[0].isIntersecting;
      render();
    }, { threshold: 0.01 });
    primaryObserver.observe(primaryButton);

    if ('MutationObserver' in window) {
      var buttonObserver = new MutationObserver(render);
      buttonObserver.observe(primaryButton, { attributes: true, attributeFilter: ['disabled'] });
    }

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        render();
      }, { threshold: 0.01 });
      footerObserver.observe(footer);
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        primaryButton.click();
      });
    }
  }

  function setupSimple(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-option]'));
    var button = root.querySelector('[data-gdp-legacy-primary]');
    var mainPrice = root.querySelector('[data-gdp-legacy-main-price]');
    var stickyPrice = root.querySelector('[data-gdp-legacy-sticky-price]');
    if (!button) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        setSelected(card, cards);
        var radio = card.querySelector('input[type="radio"]');
        var total = Number(card.getAttribute('data-price')) || 0;
        button.textContent = 'Ajouter au panier · ' + money(total, root);
        if (mainPrice) mainPrice.textContent = money(total, root);
        if (stickyPrice) stickyPrice.textContent = money(total, root);
      });
    });

    setupSticky(root, button);
  }

  function setupAlmondComposer(root) {
    var form = root.querySelector('form');
    var variants = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-format]'));
    var flavourRows = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-flavour]'));
    var primary = root.querySelector('[data-gdp-legacy-primary]');
    var builderSubmit = root.querySelector('[data-gdp-legacy-builder-submit]');
    var builder = root.querySelector('[data-gdp-legacy-almond-builder]');
    var state = root.querySelector('[data-gdp-legacy-builder-state]');
    var progress = root.querySelector('[data-gdp-legacy-progress-label]');
    var progressCount = root.querySelector('[data-gdp-legacy-count]');
    var mainPrice = root.querySelector('[data-gdp-legacy-main-price]');
    var stickyPrice = root.querySelector('[data-gdp-legacy-sticky-price]');
    var status = root.querySelector('[data-gdp-composer-status]');
    var variantInput = form && form.querySelector('input[name="id"]');
    var composition = form && form.querySelector('input[name="properties[Composition]"]');
    var properties = form ? Array.prototype.slice.call(form.querySelectorAll('[data-gdp-legacy-property]')) : [];
    var copyNode = root.querySelector('[data-gdp-composer-copy]');
    var copy;
    try { copy = JSON.parse(copyNode.textContent); } catch (_) { return; }
    if (!form || !primary || !variantInput || !composition || properties.length !== 12 ||
        flavourRows.length !== 8 || !copy || ['choose', 'ready', 'remaining', 'excess', 'add', 'from', 'not_ready'].some(function (key) { return typeof copy[key] !== 'string' || !copy[key]; })) return;

    // Names are canonical order properties, independent of the storefront language.
    var recipes = flavourRows.map(function (row) { return row.getAttribute('data-recipe'); });
    if (recipes.some(function (name, index) { return !name || recipes.indexOf(name) !== index; })) return;
    var counts = recipes.map(function () { return 0; });
    var selected = null;
    var pending = false;
    var review = false;
    var succeeded = false;
    var initialPrice = mainPrice ? mainPrice.textContent : '';

    function cartNeedsReview() {
      var bus = window.GDPCart;
      return Boolean(bus && bus.reviewRequired && bus.reviewRequired());
    }
    function locked() { return pending || review || cartNeedsReview(); }
    function plan(card) {
      if (!card || variants.indexOf(card) < 0) return null;
      var radio = card.querySelector('input[type="radio"]');
      var count = Number(card.getAttribute('data-count'));
      var cents = Number(card.getAttribute('data-price'));
      var id = card.getAttribute('data-variant-id');
      if (!radio || card.getAttribute('data-available') !== 'true' ||
          [3, 6, 12].indexOf(count) < 0 || !/^\d+$/.test(card.getAttribute('data-price') || '') || !Number.isSafeInteger(cents) || cents < 0 ||
          !/^\d+$/.test(id || '') || String(radio.value) !== id) return null;
      return { id: id, count: count, price: cents };
    }
    function names() {
      var out = [];
      recipes.forEach(function (name, i) { for (var n = 0; n < counts[i]; n += 1) out.push(name); });
      return out;
    }
    function say(message) { if (status) { status.textContent = message || ''; status.hidden = !message; } }
    function render() {
      var selection = names();
      var current = plan(selected);
      var required = current ? current.count : 0;
      var remaining = required - selection.length;
      var complete = current && remaining === 0;
      var busy = locked();
      var busLabels = window.GDPCart && window.GDPCart.labels || {};
      var description = !current ? copy.choose : remaining === 0 ? copy.ready :
        (remaining < 0 ? copy.excess : copy.remaining).replace('__count__', Math.abs(remaining));

      variants.forEach(function (card) {
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.disabled = busy || !plan(card);
      });
      flavourRows.forEach(function (row, i) {
        var plus = row.querySelector('[data-action="plus"]');
        var minus = row.querySelector('[data-action="minus"]');
        var output = row.querySelector('output');
        if (output) output.value = counts[i];
        if (plus) plus.disabled = busy || !current || remaining <= 0;
        if (minus) minus.disabled = busy || !counts[i];
      });
      if (progress) progress.textContent = description;
      if (state) state.textContent = description;
      if (progressCount) progressCount.textContent = selection.length + ' / ' + (required || '—');
      // An incomplete selection never exposes a sale variant to another form handler.
      variantInput.value = complete ? current.id : '';
      composition.value = complete ? selection.join(' · ') : '';
      properties.forEach(function (input, i) {
        input.value = complete ? selection[i] || '' : '';
        input.disabled = !complete || i >= selection.length;
      });
      var label = pending ? busLabels.adding || copy.add : review || cartNeedsReview() ? busLabels.checkCart || copy.choose :
        succeeded ? busLabels.added || copy.ready : complete ? copy.add + ' · ' + money(current.price, root) : description;
      [primary, builderSubmit].forEach(function (button) {
        if (!button) return;
        button.disabled = busy || !complete;
        button.setAttribute('aria-disabled', String(button.disabled));
        if (pending) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
        button.textContent = label;
      });
      if (mainPrice) mainPrice.textContent = current ? money(current.price, root) : initialPrice;
      if (stickyPrice) stickyPrice.textContent = current ? money(current.price, root) : copy.choose;
      if (pending) { form.dataset.gdpSubmitting = 'true'; form.setAttribute('aria-busy', 'true'); }
      else { delete form.dataset.gdpSubmitting; form.removeAttribute('aria-busy'); }
    }
    function choose(card) {
      if (locked()) {
        variants.forEach(function (item) { var radio = item.querySelector('input[type="radio"]'); if (radio) radio.checked = item === selected; });
        return;
      }
      if (!plan(card)) return;
      selected = card;
      setSelected(card, variants);
      succeeded = false;
      say('');
      // Keep existing choices on a format change; ask for removal if the new format is smaller.
      if (builder) builder.open = true;
      render();
    }
    variants.forEach(function (card) {
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', function () { if (radio.checked) choose(card); });
    });
    flavourRows.forEach(function (row, i) {
      row.addEventListener('click', function (event) {
        var button = event.target.closest('button[data-action]');
        if (!button || button.disabled || locked()) return;
        var current = plan(selected);
        if (!current) return;
        var total = names().length;
        var action = button.getAttribute('data-action');
        if (action === 'plus' && total < current.count) counts[i] += 1;
        else if (action === 'minus' && counts[i] > 0) counts[i] -= 1;
        else return;
        succeeded = false;
        say('');
        render();
      });
    });

    // Window capture precedes the shared drawer/form handler. This form has one producer.
    window.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (locked()) {
        render();
        if (!pending && window.GDPCart && window.GDPCart.showIssue) window.GDPCart.showIssue(primary, { mutationState: 'partial-or-unknown' });
        return;
      }
      var current = plan(selected);
      var selection = names();
      if (!current || selection.length !== current.count || !selected.querySelector('input[type="radio"]').checked) { render(); return; }
      var bus = window.GDPCart;
      if (!bus || typeof bus.addItems !== 'function') { say(copy.not_ready); render(); return; }
      var props = { Composition: selection.join(' · ') };
      selection.forEach(function (name, i) { props['Saveur ' + (i + 1)] = name; });
      pending = true; succeeded = false;
      render(); say(bus.labels && bus.labels.adding || copy.add);
      var request;
      try { request = bus.addItems([{ id: current.id, quantity: 1, properties: props }]); }
      catch (error) { request = Promise.reject(error); }
      Promise.resolve(request).then(function (result) {
        pending = false; succeeded = true; render();
        say(bus.labels && bus.labels.added || copy.ready);
        if (result && result.cart && result.cart.sections && result.cart.sections[bus.sectionId()]) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) { try { drawer.removeAttribute('hidden'); if (typeof drawer.show === 'function') drawer.show(); } catch (_) { bus.showIssue(primary, { mutationState: 'display' }); } }
        } else bus.showIssue(primary, { mutationState: 'display' });
      }, function (error) {
        pending = false;
        // Only a proved non-send allows a new attempt. Never replay an accepted/unknown POST.
        review = !error || error.mutationState !== 'not-sent';
        render(); say('');
        if (bus.showIssue) bus.showIssue(primary, error);
      });
    }, true);
    window.addEventListener('pageshow', function () { render(); });
    // Only an explicit, valid variant link is preselected by Liquid; no first-format fallback.
    var checked = variants.filter(function (card) { var radio = card.querySelector('input[type="radio"]'); return radio && radio.checked; });
    if (checked.length === 1 && plan(checked[0])) choose(checked[0]); else render();
    setupSticky(root, primary);
  }

  function setupHoneyComposer(root) {
    var form = root.querySelector('form');
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-slot]'));
    var presets = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-preset]'));
    var variantInput = form && form.querySelector('input[name="id"]');
    var variantNodes = Array.prototype.slice.call(root.querySelectorAll('[data-gdp-legacy-plan]'));
    var primary = root.querySelector('[data-gdp-legacy-primary]');
    var mainPrice = root.querySelector('[data-gdp-legacy-main-price]');
    var stickyPrice = root.querySelector('[data-gdp-legacy-sticky-price]');
    var progressCount = root.querySelector('[data-gdp-legacy-count]');
    var progressLabel = root.querySelector('[data-gdp-legacy-progress-label]');
    var customBuilder = root.querySelector('[data-gdp-legacy-custom-builder]');
    var priceMin = Number(root.getAttribute('data-gdp-legacy-price-min')) || 0;
    var selections = ['', '', ''];

    if (!form || !primary) return;

    function planForJujubier(count) {
      for (var index = 0; index < variantNodes.length; index += 1) {
        if (Number(variantNodes[index].getAttribute('data-jujubier-count')) === Number(count)) {
          return variantNodes[index];
        }
      }
      return null;
    }

    function render() {
      var complete = selections.filter(Boolean).length;
      var jujubierCount = selections.filter(function (value) { return value === 'Jujubier du Yémen'; }).length;
      var plan = complete === 3 ? planForJujubier(jujubierCount) : null;
      var price = plan ? Number(plan.getAttribute('data-price')) || 0 : 0;

      if (progressCount) progressCount.textContent = complete + ' / 3';
      if (progressLabel) {
        progressLabel.textContent = complete === 3 && plan
          ? 'Votre coffret est prêt'
          : complete === 3
            ? 'Cette composition est indisponible'
          : 'Encore ' + (3 - complete) + ' miel' + (3 - complete > 1 ? 's' : '');
      }
      if (variantInput) variantInput.value = plan ? plan.getAttribute('data-variant-id') : '';
      slots.forEach(function (slot, index) {
        var input = form.querySelector('input[name="properties[Miel ' + (index + 1) + ']"]');
        if (input) input.value = selections[index];
        var value = slot.querySelector('[data-gdp-legacy-slot-value]');
        if (value) value.textContent = selections[index] || 'À choisir';
        slot.classList.toggle('is-complete', Boolean(selections[index]));
      });

      primary.disabled = !plan;
      primary.setAttribute('aria-disabled', primary.disabled ? 'true' : 'false');
      primary.textContent = plan
        ? 'Ajouter au panier · ' + money(price, root)
        : complete === 3
          ? 'Composition indisponible'
          : customBuilder && customBuilder.open
            ? 'Choisissez vos 3 miels'
            : 'Choisissez un accord';
      if (mainPrice) mainPrice.textContent = plan ? money(price, root) : 'Dès ' + money(priceMin, root);
      if (stickyPrice) stickyPrice.textContent = plan ? money(price, root) : 'Dès ' + money(priceMin, root);
    }

    slots.forEach(function (slot, slotIndex) {
      slot.addEventListener('toggle', function () {
        if (!slot.open) return;
        slots.forEach(function (otherSlot) {
          if (otherSlot !== slot) otherSlot.open = false;
        });
      });
      slot.addEventListener('click', function (event) {
        var choice = event.target.closest('[data-honey]');
        if (!choice) return;
        selections[slotIndex] = choice.getAttribute('data-honey');
        setPressed(choice, Array.prototype.slice.call(slot.querySelectorAll('[data-honey]')));
        setPressed(null, presets);
        render();
        slot.open = false;
        var nextEmpty = selections.indexOf('');
        if (nextEmpty > -1 && slots[nextEmpty]) slots[nextEmpty].open = true;
      });
    });

    presets.forEach(function (preset) {
      preset.addEventListener('click', function () {
        selections = (preset.getAttribute('data-selection') || '').split('|').slice(0, 3);
        setPressed(preset, presets);
        if (customBuilder) customBuilder.open = false;
        slots.forEach(function (slot, index) {
          var choices = Array.prototype.slice.call(slot.querySelectorAll('[data-honey]'));
          var selected = choices.filter(function (item) {
            return item.getAttribute('data-honey') === selections[index];
          })[0] || null;
          setPressed(selected, choices);
          slot.open = false;
        });
        render();
      });
    });

    if (customBuilder) {
      customBuilder.addEventListener('toggle', function () {
        if (customBuilder.open && !slots.some(function (slot) { return slot.open; })) {
          var nextEmpty = selections.indexOf('');
          if (slots[nextEmpty > -1 ? nextEmpty : 0]) slots[nextEmpty > -1 ? nextEmpty : 0].open = true;
        }
        render();
      });
    }

    render();
    setupSticky(root, primary);
  }

  setupFoodDetails(document);

  if (!document.querySelector('[data-gdp-pdp-engine]')) suppressUnverifiedReviewCards();
  if (!document.querySelector('[data-gdp-pdp-engine]') && !window.GDPLegacyReviewsGuard && 'MutationObserver' in window) {
    window.GDPLegacyReviewsGuard = new MutationObserver(suppressUnverifiedReviewCards);
    window.GDPLegacyReviewsGuard.observe(document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-gdp-legacy]').forEach(function (root) {
    if (root.dataset.gdpLegacyReady === 'true') return;
    root.dataset.gdpLegacyReady = 'true';
    var kind = root.getAttribute('data-gdp-legacy');
    if (kind === 'amandes-simple') setupSimple(root);
    if (kind === 'amandes-composer') setupAlmondComposer(root);
    if (kind === 'miel-composer') setupHoneyComposer(root);
  });
})();
